import Paper from '@mui/material/Paper';
import {styled} from '@mui/material/styles';

const ContentBox = styled(Paper)(() => ({
  borderRadius: 15,
  overflow: 'hidden',
}));

export default ContentBox;
